import * as React from "react";
import ButtonLanding from "../primitive/ButtonLanding.primitive";
import CadreLanding from "../primitive/CadreLanding.primitive";
import { isNullOrUndefined } from "util";
import MedgoSampleInputLanding from "../primitive/MedgoSampleInputLanding.primitive";
import ModalLandingPageContact from "./ModalLandingPageContact.view";

declare var window;

function LandingPageMain({
  userCards,
  nextPageContact,
  ModalLandingPageRessources,
  nextPageConnect,
  ObjectifsLivreBlanc,
  nextPageLivreBlanc,
  nextPageToContact,
  nextPageMedgo,
  etablissementName,
  name,
  mobilePhone,
  email,
  modalShowContact,
  onChange,
  onHideContact,
  errorMessage,
  isLoading
}: {
  ModalLandingPageRessources: any;
  userCards: { url: string; text: string; whichSize: string }[];
  ObjectifsLivreBlanc: { title: string; description: string }[];
  nextPageContact: () => void;
  nextPageConnect: () => void;
  nextPageLivreBlanc: () => void;
  nextPageToContact: () => void;
  nextPageMedgo: () => void;
  etablissementName: string;
  name: string;
  mobilePhone: string;
  email: string;
  modalShowContact: boolean;
  onChange: (value1: string, value2: string) => void;
  onHideContact: (value: void) => void;
  errorMessage: string;
  isLoading: boolean;
}) {
  let windowInnerHeight = typeof window !== "undefined" ? window.innerHeight : 1440;
  let windowInnerWidth = typeof window !== "undefined" ? window.innerWidth : 1440;
  let width = windowInnerWidth > 992 ? "372px" : "280px";
  return (
    <div>
      <div
        className="img-medgo-fond-landing"
        style={windowInnerHeight >= 789 ? { height: "65vh" } : {}}
      >
        <ModalLandingPageContact show={modalShowContact} onHide={onHideContact} />
        {ModalLandingPageRessources}

        <div className="row margin-left-zero margin-right-zero">
          <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1">
            <h1 className="text-center text-shadow-title text-bold text-open-sans white-text text-40-responsive margin-top-130">
              Mobilisez votre personnel en temps de crise,{" "}
            </h1>
          </div>
          <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1">
            <h2 className="text-center text-shadow-title text-open-sans text-title-landing is-subtitle text-bleu text-bold">
              en toute simplicité
            </h2>
          </div>
          <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1">
            <h2 className="text-center text-shadow-title text-open-sans text-21-responsive line-30 padding-top-l mobile-top-m white-text">
              PlanBlanc est votre plateforme 100% en ligne pour mobiliser et gérer votre personnel
              en situation de crise et communiquer les informations en temps réel.
            </h2>
          </div>
          <div className="col-xs-12">
            <div className="text-center" style={{ paddingBottom: 20 }}>
              <div className="row">
                <div className="col-md-5 col-md-offset-1 col-xs-12">
                  <div className="margin-top-m-fixe">
                    <ButtonLanding
                      text="NOUS CONTACTER"
                      nextPage={nextPageToContact}
                      width={width}
                      backgroundColor="is-blue"
                    />
                  </div>
                </div>
                <div className="col-md-4 col-xs-12">
                  <div className="margin-top-m-fixe">
                    <ButtonLanding
                      text="SE CONNECTER"
                      nextPage={nextPageConnect}
                      width={width}
                      backgroundColor="is-blue"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Partenaires
        text1="Plus de "
        text2="1300 établissements "
        text3="utilisent nos solutions"
        image1="/images/Image HCL.jpg"
        image2="/images/Image GHEF.jpg"
        image3="/images/Image ELSAN.jpg"
        image4="/images/Image KORIAN.jpg"
        image5="/images/Image Vivalto.jpg"
        marginRight=" margin-main-etablissement"
        imageSize=" img-medgo-main-etablissements img-responsive img-center"
        height="20vh"
      />

      <div className="background-white">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <div className="text-open-sans text-bold text-title-landing-subpart text-center">
                <span style={{ color: "#545D70" }}>Pour quelles</span>
                <span style={{ color: "#26ADF0" }}> situations ?</span>
              </div>
            </div>
            <div className="clearfix" />

            <div className="col-xs-12">
              <div className="row" style={{ height: 250 }}>
                {userCards.map((e, i) => {
                  return (
                    <LittleImage
                      url={e.url}
                      text={e.text}
                      whichSize={e.whichSize}
                      key={"function little image " + i}
                    />
                  );
                })}
              </div>
            </div>
            <div className="col-lg-12 col-xs-10 col-xs-offset-1 col-lg-offset-0">
              <div className="text-center text-18 text-30 comet-text margin-top-l margin-bottom-xl hidden-xs">
                En situation de crise, le plan blanc permet d’organiser la prise en charge d’un
                afflux massif de victimes, tout en maintenant la continuité des soins des patients
                hospitalisés. Le déclenchement d’un plan blanc nécessite une mobilisation immédiate
                et structurée du personnel : mise en place d’une cellule de crise, rappel gradué des
                personnels et/ou maintien sur site, accueil des victimes aux urgences, circulation
                dans et autour de l'établissement...
              </div>
            </div>
          </div>
        </div>
        <div className="img-medgo-transition-main-1" />
      </div>
      <div className="background-white " id="solution">
        <div className="img-medgo-transition-main-2" />
        <div className="row">
          <div className="col-xs-12">
            <h1 className="text-center text-open-sans text-title-landing-subpart text-bold comet-text">
              <span style={{ color: "#26ADF0" }}>La solution PlanBlanc</span>
              <span> et son fonctionnement</span>
            </h1>
          </div>
          <div className="col-xs-12 col-md-8 col-md-offset-2">
            <h2 className="text-center text-open-sans comet-text text-18 line-30 margin-top-m margin-bottom-xl">
              La solution PlanBlanc est conçue pour une mobilisation immédiate de votre réseau et un
              pilotage précis de votre communication
            </h2>
          </div>

          <div>
            <div className="container">
              <div className="row">
                <div className="col-xs-12 hidden-md hidden-lg hidden-sm">
                  <img
                    className="img-responsive img-center "
                    src="/images/Image Produit 1.png"
                    alt="Trust"
                  />
                </div>
                <Etape
                  etapeTitle="Etape 1 : Intégrez la liste de diffusion de votre personnel, en toute sécurité"
                  etapeDescription=" Importez la base de votre personnel sur un serveur sécurisé, et formez les différents groupes de diffusion selon vos besoins."
                />

                <div className="col-md-6 hidden-xs">
                  <img
                    className="img-responsive img-center "
                    src="/images/Image Produit 1.png"
                    alt="Trust"
                  />
                </div>
              </div>
              <img
                className="img-responsive img-center hidden-xs"
                src="/images/Fleche Etape 1-2.png"
                alt="Trust"
                style={{
                  width: 124,
                  height: 110,
                  color: "#26ADF0"
                }}
              />
              <div className="padding-solution-etape">
                <div className="row">
                  <div className="col-md-6 col-xs-12">
                    <img
                      className="img-responsive img-center "
                      src="/images/Image Produit 2.png"
                      alt="Trust"
                    />
                  </div>
                  <Etape
                    etapeTitle="Etape 2 : Alertez votre personnel en situation de crise"
                    etapeDescription="Préparez votre message d’alerte en quelques secondes et sélectionnez le ou les groupes de diffusion concernés. Continuez à dialoguer avec les personnes alertées tout au long du plan blanc."
                  />
                </div>
              </div>
              <img
                className="img-responsive img-center hidden-xs"
                src="/images/Fleche Etape 2-3.png"
                alt="Trust"
                style={{
                  width: 124,
                  height: 110,
                  color: "#26ADF0"
                }}
              />
              <div className="padding-solution-etape is-3">
                <div className="row">
                  <div className="col-xs-12 hidden-md hidden-lg hidden-sm">
                    <img
                      className="img-responsive img-center "
                      src="/images/Image Produit 1.png"
                      alt="Trust"
                    />
                  </div>
                  <Etape
                    etapeTitle="Etape 3 : Pilotez la gestion de crise en temps réel"
                    etapeDescription="Suivez l’avancement de la mobilisation depuis votre tableau de bord, et communiquez les ajustements nécessaires."
                  />
                  <div className="col-md-6 hidden-xs">
                    <img
                      className="img-responsive img-center "
                      src="/images/Image Produit 3.png"
                      alt="Trust"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="img-medgo-transition-main-1" />
          <div className="img-medgo-transition-main-2" />

          <div id="livreblanc" className="col-xs-12">
            <h1 className="text-center text-open-sans text-title-landing-subpart text-bold comet-text">
              <span style={{ color: "#26ADF0" }}>Notre livre blanc</span>
              <span> à télécharger</span>
            </h1>
          </div>
          <div className="margin-bottom-xl">
            <LivreBlanc
              nextPage={nextPageLivreBlanc}
              backgroundColor="is-blue"
              image="/images/MEDGO_livre_blanc_02_2018 - web.png"
              subject="La mobilisation des ressources humaines en cas de plan blanc"
              objectifs={ObjectifsLivreBlanc}
              margin=" margin-left-l"
            />
          </div>
        </div>
        <div id="demo" className="img-medgo-transition-main-3" />
        <h2 className="text-center text-open-sans text-title-landing  margin-top-xl mobile-top-l">
          Vous voulez en savoir davantage ?
        </h2>
        <h2 className="text-center text-open-sans medgo-blue text-50-responsive ">
          Demandez une démonstration
        </h2>
        <div className="row">
          <div className="col-md-6 col-md-offset-3 col-xs-12">
            <div
              className="box-contact is-background-dark margin-top-xl mobile-top-l margin-bottom-xl mobile-bottom-xl"
              style={{ position: "relative" }}
              id="contact"
            >
              <div className="row">
                <div className="col-xs-12">
                  <div className="hero">
                    <MedgoSampleInputLanding
                      label="Établissement"
                      placeholder="Nom de l'établissement"
                      onChange={newValue => onChange("etablissementName", newValue)}
                      value={etablissementName}
                      color="white-text"
                    />
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="hero">
                    <MedgoSampleInputLanding
                      label="Nom complet"
                      placeholder="NOM Prénom"
                      onChange={newValue => onChange("name", newValue)}
                      value={name}
                      color="white-text"
                    />
                  </div>
                </div>

                <div className="col-xs-12">
                  <div className="hero">
                    <MedgoSampleInputLanding
                      label="Numéro de téléphone"
                      placeholder="0600000000"
                      onChange={newValue => onChange("mobilePhone", newValue)}
                      value={mobilePhone}
                      color="white-text"
                    />
                  </div>
                </div>

                <div className="col-xs-12">
                  <div className="hero">
                    <MedgoSampleInputLanding
                      label="Adresse e-mail"
                      placeholder="nom@etablissement.com"
                      onChange={newValue => onChange("email", newValue)}
                      value={email}
                      color="white-text"
                    />
                  </div>
                </div>

                <div className="col-xs-12">
                  <div className="text-center margin-top-m-fixe">
                    <ButtonLanding
                      text="ME CONTACTER"
                      nextPage={nextPageContact}
                      isLoading={isLoading}
                      errorMessage={errorMessage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="img-medgo-fin-solution padding-bottom-l">
        <div className="row">
          <div className="col-md-6 col-lg-4 col-xs-10 col-xs-offset-1">
            <CadreLanding
              text="Venez découvrir notre solution de gestion des remplacements pour les structures sanitaires et médico-sociales"
              nextPage={nextPageMedgo}
              margin=" margin-top-l margin-bottom-l"
              textButton="ACCÉDER À MEDGO.FR"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
function Partenaires({
  text1,
  text2,
  text3,
  image1,
  image2,
  image3,
  image4,
  image5,
  marginRight,
  imageSize,
  isLarge = false,
  height
}: {
  text1: string;
  text2: string;
  text3?: string;
  image1: string;
  image2: string;
  image3: string;
  image4: string;
  image5: string;
  marginRight: string;
  imageSize: string;
  isLarge?: boolean;
  height?: string;
}) {
  let windowInnerHeight = typeof window !== "undefined" ? window.innerHeight : 1440;

  let windowInnerWidth = typeof window !== "undefined" ? window.innerWidth : 1440;
  let padding = isLarge ? " padding-bottom-l " : " padding-bottom-s";
  return (
    <div
      className={"background-black" + padding}
      style={windowInnerHeight >= 789 ? { height } : {}}
    >
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <div className="text-center ">
              <h2 className="text-30-responsive hero margin-bottom-m text-white text-open-sans">
                <span>{text1} </span>
                <span style={{ color: "#26ADF0" }}>{text2}</span>
                <span>{text3}</span>
              </h2>
            </div>
          </div>
          <div className="clearfix" />
          <div className="col-xs-12 hidden-sm hidden-lg hidden-md">
            <div className="row">
              <div className="col-xs-12 text-center">
                <img className={imageSize} style={{ display: "inline" }} src={image1} />
              </div>
              <div className="col-xs-12 text-center">
                <img className={imageSize} style={{ display: "inline" }} src={image2} />
              </div>
              <div className="col-xs-12 text-center">
                <img className={imageSize} style={{ display: "inline" }} src={image3} />
              </div>
              <div className="col-xs-12 text-center">
                <img className={imageSize} style={{ display: "inline" }} src={image4} />
              </div>
              <div className="col-xs-12 text-center">
                <img
                  className={imageSize + " margin-bottom-m"}
                  style={{ display: "inline" }}
                  src={image5}
                />
              </div>
            </div>
          </div>
          <div className="hidden-xs">
            <div className="row">
              <img className={marginRight + imageSize} style={{ display: "inline" }} src={image1} />
              <img className={marginRight + imageSize} style={{ display: "inline" }} src={image2} />
              <img className={marginRight + imageSize} style={{ display: "inline" }} src={image3} />

              <img className={marginRight + imageSize} style={{ display: "inline" }} src={image4} />
              <img className={marginRight + imageSize} style={{ display: "inline" }} src={image5} />
            </div>
          </div>
        </div>
      </div>
      <div className="clearfix" />
    </div>
  );
}
function LivreBlanc({
  nextPage,
  backgroundColor,
  subject,
  image,
  objectifs,
  margin
}: {
  nextPage: () => void;
  backgroundColor: "is-blue" | "";
  image: string;
  subject: string;
  objectifs: { title: string; description: string }[];
  margin: string;
}) {
  return (
    <div className="row">
      <div className="padding-top-xl padding-bottom-xl">
        <div className="col-md-2 hidden-xs hidden-sm" />
        <div className="col-md-4 col-xs-12 col-lg-3">
          <div className="row">
            <img className=" margin-bottom-m img-responsive img-center" src={image} alt="Trust" />
          </div>
        </div>
        <div className="col-md-5 col-xs-12">
          <div className="row">
            <div>
              <h2 className="text-35 comet-text text-open-sans line-42 margin-left-l">{subject}</h2>
              <h3 className="text-16 comet-text text-open-sans line-22 margin-left-l margin-top-l">
                Ce livre vise à :
                <br />
                {!isNullOrUndefined(objectifs) &&
                  objectifs.map((e, i) => {
                    return (
                      <div key={"Objectifs " + i}>
                        - <strong>{e.title}</strong>
                        {e.description}{" "}
                      </div>
                    );
                  })}
              </h3>
              <h3 className="text-16 comet-text text-bold text-open-sans line-22 margin-left-l margin-top-l">
                Auteurs
                <br />
                <span style={{ color: "#26ADF0" }}>Thomas BERTRAND</span>
                <span>, Élève Directeur d'Hôpital EHESP</span>
                <br />
                <span style={{ color: "#26ADF0" }}>Antoine LORON</span>
                <span>, Président de medGo</span>
              </h3>
              <div className={margin + " margin-top-m-fixe"}>
                <ButtonLanding
                  text={"TÉLÉCHARGER LE LIVRE BLANC"}
                  nextPage={nextPage}
                  backgroundColor={backgroundColor}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function LittleImage({ url, text, whichSize }: { url: string; text: string; whichSize: string }) {
  let windowInnerWidth = typeof window !== "undefined" ? window.innerWidth : 1440;
  let leftSmall = windowInnerWidth < 992 ? (windowInnerWidth - 330) / 2 : null;
  return (
    <div className="col-xs-12 col-md-4">
      <div style={{ position: "relative", height: 190 }}>
        <div className={"img-medgo-main " + url} style={{ position: "absolute", left: leftSmall }}>
          <div className="row">
            <div className="col-xs-10 col-xs-offset-1">
              <div className="hero has-padding is-small">
                <div
                  className={
                    " text-center text-bold is-white line-30 text-titre-img-medgo-main " + whichSize
                  }
                >
                  {text}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Etape({ etapeTitle, etapeDescription }: { etapeTitle: string; etapeDescription: string }) {
  return (
    <div className="col-md-6 col-xs-12">
      <div className="text-title-etape-solution">
        <span style={{ fontWeight: "bold", color: "#F6593B" }}>{etapeTitle}</span>
      </div>
      <div className="text-description-etape-solution">
        <span style={{ fontWeight: "normal", color: "#545D70" }}>{etapeDescription}</span>
      </div>
    </div>
  );
}
module.exports = LandingPageMain;



// WEBPACK FOOTER //
// ./assets/react/views/Landing/landingpagemain.view.tsx